import { DataGrid } from '@mui/x-data-grid';
import { useState } from 'react';
import { Typography, IconButton, Stack } from '@mui/material';
import CustomPagination from '../../../shared/utils/CustomPagination';
import DataGridSkeleton from '../../../shared/components/DataGridSkeleton';
import EditIcon from '@mui/icons-material/Edit';
import ToggleSwitch from '../../../shared/utils/CustomToggle';
import { useToaster } from '../../../shared/utils/ToasterProvider';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import api from '../../../assets/nodeApi/axiosInstance';


const CountryTableList = ({ countryRows, isLoading = false, onEdit }) => {
    const [paginationModel, setPaginationModel] = useState({ page: 0, pageSize: 10 });
    const { showToaster } = useToaster();
    const queryClient = useQueryClient();
    const mutationUpdate = useMutation({
        mutationFn: ({ data, id }) =>
            api.put(`region/update-status/${id}`, data),
    });
    const handleToggleChange = (row) => {
        const obj = {
            "table": "countries",
            "status": row?.status == 1 ? false : true
        }
        mutationUpdate.mutate({ data: obj, id: row?.id }, {
            onSuccess: (response) => {
                if (response?.data?.message) {
                    showToaster("Country updated successfully!", '', 'success');
                    queryClient.invalidateQueries({ queryKey: ["countries-all-list"] });

                } else {
                    showToaster('Something went wrong!', '', 'error');
                }
            },
            onError: (error) => {
                showToaster(error?.data?.error || "Failed to update country", '', 'error');
            }
        });
    };
    const countryColumns = [
        {
            field: "sr_no",
            headerName: "Sr No",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>

        },
        {
            field: "country_name",
            headerName: "Country Name",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        },

        {
            field: "continent_code",
            headerName: "Continent Code",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        },
        {
            field: "status",
            headerName: "Status",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value === 1 ? "Active" : "Inactive"}</Typography>,
        },
        {
            field: "actionsEdit",
            headerName: "Edit",
            flex: 1,
            renderCell: (params) => (
                <Stack direction="row" spacing={1}>
                    <IconButton
                        onClick={() => onEdit && onEdit(params.row)}
                        size="small"
                    >
                        <EditIcon color="text.primary" />
                    </IconButton>
                </Stack>
            ),
        },
        {
            field: "actionsDelete",
            headerName: "Change Status",
            flex: 1,
            renderCell: (params) => (
                <Stack direction="row" spacing={1}>
                    <ToggleSwitch checked={params?.row?.status} onCheck={() => handleToggleChange(params?.row)} />
                </Stack>
            ),
        }
    ];
    return (
        <>
            {isLoading ? (
                <DataGridSkeleton rowsNum={10} />
            ) : (
                <DataGrid
                    rows={countryRows}
                    columns={countryColumns}
                    pagination
                    paginationModel={paginationModel}
                    onPaginationModelChange={setPaginationModel}
                    pageSizeOptions={[10]}
                    disableRowSelectionOnClick={true}
                    slots={{
                        pagination: () => (
                            <CustomPagination
                                paginationModel={paginationModel}
                                setPaginationModel={setPaginationModel}
                                totalRows={countryRows?.length || 0}
                                pageSize={paginationModel.pageSize}
                            />
                        ),
                    }}
                />
            )}
        </>
    )
}

export default CountryTableList